<template>
  <div class="license-pc">
    <div class="box">
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/2021年12月23日-高新技术企业证书.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/2023年4月10日-专精特新中小企业.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/2022年12月18日-创新型中小企业.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/2023年10月10日-互联网药品信息服务资格证.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/zzdx.png')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/zzdx-2.png')"
      />
      <!-- <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/2019年8月1日-增值电信业务经营许可证(1).jpg')"
      /> -->
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/药品网络交易服务第三方平台备案凭证.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/CRM软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/商城软著-ios.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/商城软著-安卓.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/大数据软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/客服软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/推荐系统软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/财务软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/运营中心软著.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/HN-ZZ20231031001医疗器械网络交易服务第三方平台备案凭证.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/HN-ZZ20220111001.jpg')"
      />
      <van-image
        width="25%"
        height="100%"
        :src="getImgUrl('publicMobile/license/1712028500598.jpg')"
      />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Image as VanImage } from "vant";
import { getImgUrl } from "@/utils/tools";
Vue.use(VanImage);
export default {
  props: {},
  data() {
    return {};
  },
  components: {},
  created() {},
  methods: {
    getImgUrl,
  },
};
</script> 

<style lang="scss" scoped>
.license-pc {
  min-height: 100vh;
  background-color: #ffffff;
  .box {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
